export const UNITE_TONNE = 'TONNE'
export const UNITE_HECTARE = 'HECTARE'

export const valeurSelonUnite = (champ, unite) => {
  if (champ == null) {
    return null
  }
  const montant = unite === UNITE_HECTARE ? champ.montantEnEuroParHectare : champ.montantEnEuroParTonne
  return montant != null ? montant : null
}

export const estMontantNul = (champ) => {
  if (champ == null) {
    return true
  }
  return [champ.montantEnEuroParTonne, champ.montantEnEuroParHectare]
    .every((montant) => montant == null || montant === 0)
}

export const arrondir = (valeur) => {
  if (valeur == null || Number.isNaN(valeur)) {
    return null
  }
  return Math.round(valeur)
}

export const doitAfficherLigne = (valeurAdherent, valeurGroupe) => {
  const adherentVide = valeurAdherent == null || valeurAdherent === 0
  if (!adherentVide) {
    return true
  }
  if (valeurGroupe === undefined) {
    return true
  }
  const groupeVide = valeurGroupe == null || valeurGroupe === 0
  return !groupeVide
}

export const GROUPE_SUPERIEUR = 'SUPERIEUR'
export const GROUPE_INFERIEUR = 'INFERIEUR'
export const GROUPE_NEUTRE = 'NEUTRE'
export const GROUPE_INSUFFISANT = 'INSUFFISANT'
export const GROUPE_INCONNU = 'INCONNU'
export const QUARTILE_SUPERIEUR = 'QUARTILE_SUP'
export const QUARTILE_INFERIEUR = 'QUARTILE_INF'


export const repartitionSelonUnite = (champGroupe, unite) => {
  if (champGroupe === undefined) {
    return undefined
  }
  if (champGroupe == null) {
    return null
  }
  const repartition = unite === UNITE_HECTARE
    ? champGroupe.repartitionGroupeMontantParHectare
    : champGroupe.repartitionGroupeMontantParTonne
  return repartition != null ? repartition : null
}

export const valeurGroupeSelonUnite = (champGroupe, unite) => {
  const repartition = repartitionSelonUnite(champGroupe, unite)
  if (repartition === undefined) {
    return undefined
  }
  return repartition != null && repartition.valeurMoyenneDuGroupe != null
    ? repartition.valeurMoyenneDuGroupe
    : null
}

export const positionDansGroupe = (repartition) => {
  if (repartition === undefined) {
    return GROUPE_INCONNU
  }
  if (repartition == null || repartition.valeurMoyenneDuGroupe == null) {
    return GROUPE_INSUFFISANT
  }
  if (repartition.codePositionDuNumtiers === QUARTILE_SUPERIEUR) {
    return GROUPE_SUPERIEUR
  }
  if (repartition.codePositionDuNumtiers === QUARTILE_INFERIEUR) {
    return GROUPE_INFERIEUR
  }
  return GROUPE_NEUTRE
}

